import React from "react"
import { Icon } from "lib"

const SimpleIcon = ({ domRef, info, value, ...props }) => {
    if (!value) return null

    return <Icon name={value} ref={domRef} {...props} />
}
export default React.memo(SimpleIcon)
